import { withStyles } from '@material-ui/styles';
import { Field, Form, Formik } from 'formik';
import { flowRight } from 'lodash';
import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';

import ActionsButtons from './ActionsButtons';
import styles from '../styles';
import changeObjectValues from '../../../utils/changeObjectValues';
import { actions as reduxActions } from '../reducers';
import TelephonyUsersMainSection from './TelephonyUsersMainSection';
import UserDirFields from './UserDirFields';
import { updateTelephonyUserOnSubmit } from '../actions/updateTelephonyUser';
import { mapGeneralData } from '../actions/mapDataToUpdate';
import validateSchema from '../actions/validateSchema';
import OtherSettings from './OtherSettings';
import AnsweringPlaces from './AnsweringPlaces';
import PhoneNumbers from './PhoneNumbers';
import { translate } from '../../../i18n/I18nProvider';

function UserGeneralDataForm({
  classes,
  isDomainProvided,
  clientConnectId,
  selectsOptions = {},
  updateTelephonyUserOnSubmit,
  generalData = {},
  mitelUserId,
  clientId,
  resetUser,
  fromUsersTable
}) {
  const [numberErrors, setNumberErrors] = useState({});
  const closeAfterSaveRef = useRef(false);

  const onSubmit = useCallback(
    values => {
      const mappedValues = mapGeneralData({
        values,
        languages: selectsOptions.languages
      });
      updateTelephonyUserOnSubmit({
        values,
        userData: mappedValues,
        clientConnectId,
        mitelUserId,
        clientId,
        isGeneralData: true,
        fromUsersTable,
        closeOnSuccess: closeAfterSaveRef.current
      });
      closeAfterSaveRef.current = false;
    },
    // eslint-disable-next-line
    [updateTelephonyUserOnSubmit, selectsOptions]
  );

  return (
    <Formik
      initialValues={{
        ...changeObjectValues(generalData, null, '')
      }}
      enableReinitialize
      validateOnBlur={true}
      validateOnChange={false}
      onSubmit={onSubmit}
      validationSchema={validateSchema().telephonyUser}
    >
      {({
        handleSubmit,
        dirty,
        errors,
        initialValues,
        setFieldError,
        setFieldTouched,
        validateForm
      }) => {
        const allErrors = { ...errors, ...numberErrors };

        return (
          <Form onSubmit={handleSubmit}>
            <div className={classes.content}>
              <Field
                component={TelephonyUsersMainSection}
                selectsOptions={selectsOptions}
                initialValues={initialValues}
                isDomainProvided={isDomainProvided}
              />
              <Field component={UserDirFields} initialValues={initialValues} />
              <Field
                component={AnsweringPlaces}
                numberErrors={numberErrors}
                setNumberErrors={setNumberErrors}
              />
              <Field
                component={PhoneNumbers}
                initialValues={initialValues}
                numberErrors={numberErrors}
                setNumberErrors={setNumberErrors}
                errors={errors}
                setFieldError={setFieldError}
                setFieldTouched={setFieldTouched}
                validateForm={validateForm}
              />

              <Field component={OtherSettings} />
            </div>
            {Object.keys(allErrors).length > 0 && (
              <div
                style={{
                  color: '#f44336',
                  marginBottom: '16px',
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: '500',
                  backgroundColor: '#ffebee',
                  border: '1px solid #ffcdd2',
                  borderRadius: '4px',
                  padding: '12px 16px',
                  margin: '0 24px'
                }}
              >
                {translate('USER.EDIT_USER_VALIDATION_ERROR')}
              </div>
            )}
            <footer className={classes.footer}>
              <ActionsButtons
                onCloseClick={resetUser}
                handleSubmit={handleSubmit}
                handleSaveAndClose={() => {
                  closeAfterSaveRef.current = true;
                  handleSubmit();
                }}
                dirty={dirty}
                errors={allErrors}
              />
            </footer>
          </Form>
        );
      }}
    </Formik>
  );
}

const mapStatesToProps = ({ editUser, selectClient }) => {
  return {
    ...editUser,
    generalData: editUser.user.generalData,
    clientId: selectClient.selectedClient.id
  };
};

const mapDispatchToProps = {
  ...reduxActions,
  updateTelephonyUserOnSubmit
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(UserGeneralDataForm);
